import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { api } from "../../Config/ApiInterface";
import qs from "qs"; 
import {
  roomTypeFailure,
  roomTypeSuccess,
  addRoomTypeSuccess,
  addRoomTypeFailure,
  deleteRoomTypeSuccess,
  deleteRoomTypeFailure,
  patchRoomTypeFailure,
  patchRoomTypeSuccess,
  getAllRoomNumberWithIDSuccess,getAllRoomNumberWithIDFailure,
  getAllRoomTypeWithIDSuccess,
  getAllRoomTypeWithIDFailure,
  roomTypeNameSuccess,
  roomTypeNameFailure,
  roomStatusSuccess,
  roomStatusFailure,
  getRoomListFailure,getRoomListSuccess
} from "../../Actions";

const getErrorMessage = (error, fallback) => {
  return error?.response?.data?.message || fallback;
};

const getSuccessMessage = (response, fallback) => {
  return response?.data?.message || fallback;
};

function* roomTypeSaga(action) {
  try {

      let hotel_id=localStorage.getItem('hotel_id');

    const queryString = qs.stringify(action.payload); 
    const response = yield call(api.post, `/room/room-types?hotel_id=${hotel_id}&${queryString}`);
    yield put(roomTypeSuccess(response.data));
} catch (error) {
    const message = getErrorMessage(error, "Failed to fetch room types.");
    yield put(roomTypeFailure(message));
    toast.error(message);
  }
}
function* roomTypeNameSaga(action) {
  try {
    let hotel_id = localStorage.getItem("hotel_id");
    const response = yield call(api.post, `/room/all-room-types?hotel_id=${hotel_id}`);
    yield put(roomTypeNameSuccess(response.data));
} catch (error) {
    const message = getErrorMessage(error, "Failed to fetch room types.");
    yield put(roomTypeNameFailure(message));
    // toast.error(message);
  }
}
function* roomStatusSaga(action) {
  try {
    const response = yield call(api.post, `/room/all-room-status`);
    yield put(roomStatusSuccess(response.data));
} catch (error) {
    const message = getErrorMessage(error, "Failed to fetch booking status.");
    yield put(roomStatusFailure(message));
    toast.error(message);
  }
}

function* addRoomTypeSaga(action) {
  try {
    const response = yield call(api.post, `/room/create-room-type`, action.payload);
    yield put(addRoomTypeSuccess(response.data));
    toast.success(getSuccessMessage(response, "Room type added successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to add room types.");
    yield put(addRoomTypeFailure(message));
    toast.error(message);
  }
}

function* deleteRoomTypeSaga(action) {
  try {
    const response = yield call(api.delete, `/room/delete-room-type/${action.payload}`);
    yield put(deleteRoomTypeSuccess(response.data));
    toast.success(getSuccessMessage(response, "Room type deleted successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to delete room type.");
    yield put(deleteRoomTypeFailure(message));
    toast.error(message);
  }
}

function* patchRoomTypeSaga(action) {
  try {
    const { id: room_id, data } = action.payload;
    const response = yield call(api.patch, `/room/update-room-type/${room_id}`, data);
    yield put(patchRoomTypeSuccess(response.data));
    toast.success(getSuccessMessage(response, "Room type updated successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to update room type.");
    yield put(patchRoomTypeFailure(message));
    toast.error(message);
  }
}


function* getAllRoomNumberWithID(action) {
  try {
    let hotel_id=localStorage.getItem('hotel_id');

    const response = yield call(api.post, `/room/all-room-number?hotel_id=${hotel_id}`);
    yield put(getAllRoomNumberWithIDSuccess(response));
    // toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to update room Reassign.");
    yield put(getAllRoomNumberWithIDFailure(message));
    // toast.error(message);
  }
}

function* getAllRoomTpyeWithID(action) {
  try {
    let hotel_id = localStorage.getItem("hotel_id");

    const response = yield call(api.post, `/room/all-room-types?hotel_id=${hotel_id}`);
    yield put(getAllRoomTypeWithIDSuccess(response));
    // toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to update room Reassign.");
    yield put(getAllRoomTypeWithIDFailure(message));
    // toast.error(message);
  }
}

function* getRoomNumberList(action) {
  try {
    let params={};
    let in_house=false;
    let start_date=encodeURIComponent((new Date(Date.now())).toISOString());
    if(action.payload){
      params=action.payload
      if(action.payload?.type==='in-house'){
        in_house=true
      }
    }
    let hotel_id=localStorage.getItem('hotel_id');
    const response = yield call(api.post, `/room/get-room-list?hotel_id=${hotel_id}&in_house=${in_house}&${in_house ?`start_date=${start_date}` :params}`);
    yield put(getRoomListSuccess(response));
    // toast.success(getSuccessMessage(response, "Room Reassign successfully."));
  } catch (error) {
    const message = getErrorMessage(error, "Failed to get rooms.");
    yield put(getRoomListFailure(message));
    // toast.error(message);
  }
}
export {
  roomTypeSaga,
  addRoomTypeSaga,
  deleteRoomTypeSaga,
  patchRoomTypeSaga,
  roomTypeNameSaga,
roomStatusSaga,
getRoomNumberList,
  getAllRoomNumberWithID,
  getAllRoomTpyeWithID,
};
